import { BasePopup } from 'components/Display/BasePopup/BasePopup';
import { Button } from 'components/Form/Button/Button';
import { useTranslation } from 'react-i18next';
import { logError } from 'services/logging/logging';
import { NotificationType, useNotificationStore } from 'stores/notifications/notifications';

export const EmailModal = ({ open, onClose, emailBody }: { open: boolean; onClose: () => void; emailBody: string }) => {
  const { t } = useTranslation();
  const { addNotification } = useNotificationStore();
  const onCopy = () => {
    navigator.clipboard
      .write([
        new ClipboardItem({
          'text/html': new Blob([emailBody], { type: 'text/html' }),
          'text/plain': new Blob([emailBody.replace(/<[^>]*>/g, '')], { type: 'text/plain' }),
        }),
      ])
      .then(
        () => {
          onClose();
          addNotification(
            t('invoiceVerification:detailsPage.generateDiscrepancyEmail.copyEmail.success'),
            NotificationType.success,
          );
        },
        (err) => {
          logError(err);
          addNotification(
            t('invoiceVerification:detailsPage.generateDiscrepancyEmail.copyEmail.error'),
            NotificationType.error,
          );
        },
      );
  };
  return (
    <BasePopup open={open} setOpen={onClose} width="xl">
      <BasePopup.Body>
        <h1 className="text-lg font-semibold text-gray-900">
          {t('invoiceVerification:detailsPage.generateDiscrepancyEmail.copyEmailModal.title')}
        </h1>
        <div
          className="mt-2 max-h-96 overflow-auto rounded-md bg-gray-50 p-4 text-sm text-gray-700"
          dangerouslySetInnerHTML={{ __html: emailBody }}
        ></div>
        <div className="mt-4 flex items-center justify-end gap-2">
          <Button
            variant="secondary"
            onClick={onClose}
            analyticsId="invoiceVerification:generateDiscrepancyEmail.close"
          >
            {t('common:cancel')}
          </Button>
          <Button variant="primary" onClick={onCopy} analyticsId="invoiceVerification:generateDiscrepancyEmail.copy">
            {t('invoiceVerification:detailsPage.generateDiscrepancyEmail.copyEmailModal.copy')}
          </Button>
        </div>
      </BasePopup.Body>
    </BasePopup>
  );
};
